// shipment-price-gap (2026-09-30): a line assigned to a shipment whose freight
// has not been allocated yet is NOT PRICED -- it would show freight 0, a
// confident number the save then changes. A gap in the quote, not a failed
// request, so the same warning tone as UnpricedBanner; derived on every render
// so it clears by itself when the allocation lands on the row.

import { AlertTriangle } from "lucide-react";
import {
  semanticColors, radius, spacing, typography, iconSize, iconStroke,
} from "@/styles/tokens";

export function FreightPendingBanner({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div
      data-testid="quote-freight-pending"
      className="flex items-start"
      style={{
        gap: spacing[8], marginTop: spacing[12],
        padding: `${spacing[8]}px ${spacing[12]}px`,
        backgroundColor: semanticColors.warningBg,
        border: `1px solid ${semanticColors.warningBorder}`,
        borderRadius: radius.base, fontSize: typography.fontSize.sm,
        color: semanticColors.warningTextOnTint,
      }}
    >
      <AlertTriangle
        size={iconSize.md} strokeWidth={iconStroke.regular}
        style={{ flexShrink: 0, marginTop: spacing[2], color: semanticColors.warning }}
      />
      <span>{message}</span>
    </div>
  );
}
